import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";
import { SecondaryFilter } from "../../Dashboards/AdminDashboard/models/SecondaryFilter";

export const PROMPTS_FILTERS = {
  MAIN: {
    mainFilterKey: "prompt",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    secondaryFilters: [] as SecondaryFilter[],
    initial: true,
    placeholder:
      "Escriba el nombre del prompt o utiliza los filtros para agrupar información"
  },
  SECONDARY: {
    NAME: {
      name: "Nombre",
      placeholder: "Nombre de Prompt",
      key: "name",
      avatar: "mdi-form-textbox",
      type: "secondaryFilter",
      default: true,
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "unique"
    },
    STATUS: {
      name: "Estado",
      placeholder: "Estado de prompt",
      key: "promptState",
      avatar: "mdi-list-status",
      type: "secondaryFilter",
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "list",
      options: [
        { name: "Activo", key: "Activo" },
        { name: "Inactivo", key: "Inactivo" }
      ]
    }
  }
};

export const PAGE_PROMPTS_TITLE_SEARCH = "Consulta de prompts";
export const PAGE_PROMPTS_TITLE_CREATE = "Crear prompt";
export const ADD_PROMPT_TEXT = "Agregar prompt";
